import { QueryClient } from "@tanstack/react-query";

import { ApiError } from "../api/client";

export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // a 4xx is an answer, not a hiccup: never retried
        retry: (count, error) => !(error instanceof ApiError && error.status >= 400 && error.status < 500) && count < 2,
        staleTime: 30_000,
      },
    },
  });
}
